{
    "rapormusteridetay": {
        "Baslik": "Müşteri Detay Raporu",
        "ID": "#",
        "Musteri": "Müşteri",
        "Referans": "Referans",
        "Kullanici": "Kullanıcı",
        "Randevu": "R",
        "SatisOnayli": "S",
        "SatisOnaysiz": "O",
        "SatisIptal": "İ",
        "SatisCayma": "C",
        "UrunSayisi": "Ü",
        "UrunSayisiTam": "Ürün Sayısı",
        "Olusturan": "Oluşturan",
        "Olusturma": "Oluşturma",
        "Ad": "Ad",
        "Soyad": "Soyad",
        "Cep": "Cep",
        "ExcelAktar": "Excel Aktar",
        "Ara": "Ara",
        "MusteriDetay": "Müşteri Detay",
        "Bilgisi": "Bilgisi",
        "Randevular": "Randevular",
        "Satislar": "Satışlar",
        "Loglar": "Loglar",
        "Aktarma": "Aktarma",
        "GeciciYetki": "Geçici Yetki",
        "Tasi": "Taşı",
        "Guncelle": "Güncelle",
        "Kapat": "Kapat",
        "Tarih": "Tarih",
        "Saat": "Saat",
        "Gorusme": "Görüşme",
        "Ulasim": "Ulaşım",
        "Sonuc": "Sonuç",
        "Aciklama": "Açıklama",
        "SigortaEttiren": "Sigorta Ettiren",
        "Urun": "Ürün",
        "PoliceNo": "Poliçe No",
        "TutarTL": "Tutar (₺)",
        "TutarDolar": "Tutar ($)",
        "Kur": "Kur",
        "Ape": "Ape",
        "Not": "Not",
        "Durum": "Durum",
        "Filtrele": "Filtrele",
        "MusteriBilgileri": "Müşteri Bilgileri",
        "KendiKayitlarim": "Kendi Kayıtlarım",
        "TakimKayitlarim": "Takım Kayıtlarım",
        "SubeKayitlarim": "Şube Kayıtlarım",
        "TumKayitlar": "Tüm Kayıtlar",
        "Gorunum": "Görünüm",
        "MusteriAdSoyad": "Müşteri Adı / Soyadı",
        "Takim": "Takım",
        "Sube": "Şube",
        "OlusturmaBaslangic": "Oluşturma Başlangıç",
        "OlusturmaBitis": "Oluşturma Bitiş",
        "SatisBilgileri": "Satış Bilgileri",
        "OnayliSatisFiltresi": "Onaylı Satış Filtresi",
        "Kriter": "Kriter",
        "Deger": "Değer",
        "UrunSecimi": "Ürün Seçimi",
        "SatisBaslangic": "Satış Başlangıç",
        "SatisBitis": "Satış Bitiş",
        "RandevuBilgileri": "Randevu Bilgileri",
        "RandevuFiltresi": "Randevu Filtresi",
        "RandevuBaslangic": "Randevu Başlangıç",
        "RandevuBitis": "Randevu Bitiş",
        "Sifirla": "Sıfırla",
        "RandevuSayisi": "Randevu Sayısı",
        "OnaysizSatis": "Onaysız Satış",
        "OnayliSatis": "Onaylı Satış",
        "IptalSatis": "İptal Satış",
        "CaymaSatis": "Cayma Satış",
        "Esittir": "Eşittir (=)",
        "BuyukEsittir": "Büyük Eşittir (>=)",
        "Kucuk": "Küçük (<)",
        "KucukEsittir": "Küçük Eşittir (<=)"
    }
}
